export default __webpack_public_path__ + "static/media/Big-chicken.bd4ea7bc.svg";